import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue'
import { updateApplicationInfo } from '@/api'
import { CODE_ENUM } from '@/common'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const mapRef = ref()
const formRef = ref()

const formData: any = ref({
  desc: '',
})

const title = computed(() => {
  return props.data?.name ? '修改资源名称' : '修改资源描述'
})

const label = computed(() => {
  return props.data?.name ? '资源名称' : '资源描述'
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      formData.value.desc = props.data?.name || props.data?.desc
    }
  }
)

const rules: any = {
  desc: [{ required: true, message: '请输入' }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true
  const key = props.data?.name ? 'name' : 'describe'
  const res: any = await updateApplicationInfo({
    [key]: formData.value.desc,
    resourceId: props.data?.id,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: title.value,
    width: "480",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [
          _createTextVNode(" 取消 ")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 确定 ")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: label.value,
            prop: "desc"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.desc,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.desc) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})